import { AxiosResponse } from 'axios';
import { useCallback } from 'react';

import { MoveTokenResponse } from '@/types/api/mypage/moveTokenResponse';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';

/** 引越し手続き用トークン生成APIのURL */
const url = ApiUrl.Write.MOVE_TOKEN_CREATE;

/**
 * 引越し手続き用トークン生成APIの呼び出しフック。
 * 外部導線や次画面へ安全に引き継ぐための一時トークンを発行する。
 *
 * @returns execute - API実行関数
 */
const useGetMoveTokenCreate = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<MoveTokenResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetMoveTokenCreate;
